import { Reveal } from "./Reveal";
import { ArrowRight } from "lucide-react";
import { IMAGES, USE_CASES } from "../lib/data";

const Row = ({ uc }) => {
  const imageRight = uc.align === "right";
  const go = () => document.querySelector("#inquiry")?.scrollIntoView({ behavior: "smooth" });
  return (
    <div id={uc.id} data-testid={`usecase-${uc.id}`} className="scroll-mt-24 grid lg:grid-cols-2 gap-8 lg:gap-16 items-center">
      <Reveal className={imageRight ? "lg:order-2" : "lg:order-1"}>
        <div className="relative group overflow-hidden">
          <img
            src={IMAGES[uc.image]}
            alt={uc.title}
            className="w-full h-[280px] sm:h-[380px] md:h-[520px] object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-black/25" />
          <div className="absolute inset-0 ring-1 ring-inset ring-[#D4AF37]/20" />
        </div>
      </Reveal>

      <Reveal delay={0.12} className={imageRight ? "lg:order-1" : "lg:order-2"}>
        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-4 md:mb-5">{uc.overline}</p>
          <h3 className="font-display font-black uppercase tracking-tight text-white text-2xl sm:text-3xl md:text-5xl leading-[0.95]">
            {uc.title}
          </h3>

          {uc.campaign && (
            <div className="mt-5 md:mt-6 flex items-center gap-4 flex-wrap">
              {uc.showGolfLogo && (
                <img src={IMAGES.logoGolf} alt="Good Shot golf campaign" className="h-9 md:h-12 w-auto" />
              )}
              <span className="font-display uppercase tracking-[0.16em] text-[#D4AF37] text-sm md:text-base font-semibold">
                {uc.campaign}
              </span>
            </div>
          )}

          <p className="mt-5 md:mt-6 max-w-lg text-base md:text-lg text-white/65 font-light leading-relaxed">{uc.copy}</p>

          <button
            data-testid={`usecase-cta-${uc.id}`}
            onClick={go}
            className="mt-7 md:mt-8 inline-flex items-center gap-2 text-white uppercase tracking-[0.16em] text-xs md:text-sm hover:text-[#D4AF37] transition-colors duration-300 group"
          >
            Enquire For This Event Type
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />
          </button>
        </div>
      </Reveal>
    </div>
  );
};

export const UseCases = () => (
  <section id="environments" data-testid="usecases-section" className="relative py-20 md:py-32 border-t border-white/5 scroll-mt-24">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10">
      <Reveal>
        <h2 className="font-display font-black uppercase tracking-tight text-white/90 text-2xl md:text-3xl mb-14 md:mb-24">
          Signature <span className="text-[#D4AF37]">environments.</span>
        </h2>
      </Reveal>
      <div className="space-y-20 md:space-y-36">
        {USE_CASES.map((uc) => (
          <Row key={uc.id} uc={uc} />
        ))}
      </div>
    </div>
  </section>
);
